import React from 'react';
import { Popover } from 'antd';

const displayValue = (value) => {
  if (value == null || String(value).trim() === '') {
    return '—';
  }

  return String(value).trim();
};

const initialsFrom = (user) => {
  const source = String(user?.name || user?.username || '').trim();
  if (!source) {
    return '?';
  }

  const parts = source.split(/\s+/).filter(Boolean);
  const first = parts[0];
  const last = parts.length > 1 ? parts[parts.length - 1] : '';
  const letters = last ? `${first.charAt(0)}${last.charAt(0)}` : first.slice(0, 2);

  return letters.toLocaleUpperCase('sr-RS');
};

const LoggedUserBadge = ({ user, companyName, showGreeting = true }) => {
  if (!user) {
    return null;
  }

  const primary = user.name || user.username || 'Korisnik';
  const initials = initialsFrom(user);
  const greeting = !showGreeting
    ? null
    : primary === 'Korisnik'
      ? 'Dobrodošli'
      : `Dobrodošli, ${primary}`;

  const details = (
    <dl className="app-header__user-details">
      <div>
        <dt>Ime i prezime</dt>
        <dd>{displayValue(user.name)}</dd>
      </div>
      <div>
        <dt>Korisničko ime</dt>
        <dd>{displayValue(user.username)}</dd>
      </div>
      <div>
        <dt>Broj telefona</dt>
        <dd>{displayValue(user.phone_number)}</dd>
      </div>
      <div>
        <dt>Rola</dt>
        <dd>{displayValue(user.roleName)}</dd>
      </div>
      {companyName ? (
        <div>
          <dt>Kompanija</dt>
          <dd>{companyName}</dd>
        </div>
      ) : null}
    </dl>
  );

  return (
    <Popover
      trigger="click"
      placement="bottomLeft"
      classNames={{ root: 'app-header__user-popover' }}
      content={details}
    >
      <button
        type="button"
        className="app-header__user"
        aria-label={greeting ? `${greeting}. Prijavljeni korisnik: ${primary}` : `Prijavljeni korisnik: ${primary}`}
      >
        <span className="app-header__user-avatar" aria-hidden="true">
          {initials}
        </span>
        {greeting && <span className="app-header__user-name">{greeting}</span>}
      </button>
    </Popover>
  );
};

export default LoggedUserBadge;
